import {connect} from '@modifi/redux'
import {aPush, generatePath} from '@modifi/router'
import {compose} from 'ramda'
import {FeInputFieldStatus} from '@modifi/enums'

import {selectIntermediaryShareholdersAreLoading} from '../../../../data/intermediary-shareholders'
import {selectCombinedInputFieldStatusBySectionName} from '../../../../modules/input-fields'
import ShareholderSummaryPage, {ShareholderSummaryPageProps} from './ShareholderSummaryPage'
import {SECTION_INTERMEDIARY_SHAREHOLDERS} from '../../../../constants/sections'
import {selectCompanyIsLocked} from '../../../../data/company'
import {selectShareholderSummaryData} from './selector'
import {ROUTE_COMPANY_PROFILE_INTERMEDIARY_SHAREHOLDERS_CREATE} from '../../../../routes/constants'

const mapStateToProps = (
  state: Record<string, any>
): Pick<ShareholderSummaryPageProps, 'isLoading' | 'shareholderSummary' | 'isReadonly'> => {
  const companyIsLocked = selectCompanyIsLocked(state)
  const isVerified =
    selectCombinedInputFieldStatusBySectionName(state, SECTION_INTERMEDIARY_SHAREHOLDERS) ===
    FeInputFieldStatus.VERIFIED
  return {
    isLoading: selectIntermediaryShareholdersAreLoading(state),
    // @ts-expect-error to be fixed
    shareholderSummary: selectShareholderSummaryData(state),
    isReadonly: isVerified || companyIsLocked,
  }
}

const mapDispatchToProps = {
  createShareholder: (): any =>
    aPush(generatePath(ROUTE_COMPANY_PROFILE_INTERMEDIARY_SHAREHOLDERS_CREATE, {})),
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(ShareholderSummaryPage)
